import { useAppContext } from 'src/contexts/AppContext';

/**
 * The numeric ID for the POS Lite seller account type.
 * This corresponds to SellerAccountTypeId = 10 in the database.
 * Using the numeric ID rather than the SellerAccountType string enum ensures correct
 * identification of POS Lite accounts even if the enum is not yet updated in the
 * Utilities package to include PosLite = 10.
 */
const POS_LITE_SELLER_ACCOUNT_TYPE_ID = 10;

/**
 * Returns true when the active account is a POS Lite account.
 *
 * POS Lite accounts are identified by SellerAccountTypeId = 10 on the SellerAccount.
 * This is the correct identity-based check. Note that IsReadOnly is a separate
 * behavior flag used by the backend middleware to enforce API-level restrictions,
 * but it should not be used for POS Lite identification since other account types
 * may also be read-only in the future.
 */
export const usePosLiteAccount = (): boolean => {
  const { loginContext } = useAppContext();

  return (
    loginContext?.user?.activeAccount?.sellerAccountTypeId ===
    POS_LITE_SELLER_ACCOUNT_TYPE_ID
  );
};
